import React from 'react';

interface IProps {
  light?: boolean;
  
}

const SelectDownIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none" viewBox="0 0 23 23">
      <circle cx="12" cy="12" r="8" fill={props.light?"":"#122442"}/>
      <path fill={props.light?"#ccc":"#fff"} d="M7.4 9l4.6 4.6L16.6 9l1.4 1.4-6 6-6-6L7.4 9z"/>
    </svg>
  )
}

export default SelectDownIcon;